export default __webpack_public_path__ + "static/media/Cloak of the Ubah Kan.c5ff8f73.jpg";